export default __webpack_public_path__ + "static/media/icon_CO2.18ceb8ef.svg";